import { render, staticRenderFns } from "./ArchiveSales.vue?vue&type=template&id=758dc40c&"
import script from "./ArchiveSales.vue?vue&type=script&lang=js&"
export * from "./ArchiveSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveSales.vue"
export default component.exports